import { createAsyncThunk } from '@reduxjs/toolkit';
import sliceConstants from './orgManagementSectionSliceConstants';

const extraActions = {};

export default extraActions;
